import { Select } from '@billy/design-system'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { InvoiceDocumentType } from '../../../../../../../invoices/enums/invoiceDocumentType'
import { useGetZervantDocumentSettings } from '../../../../../../../invoicingSettings/hooks/useGetZervantDocumentSettings'
import { useZervantSettings } from '../../../../../../../invoicingSettings/hooks/useZervantSettings'
import { useCustomerForm } from '../../../../contexts/customerFormContext'

export const PaymentTerm = () => {
  const { t } = useTranslation()
  const { data, isLoading: isLoadingSettings } = useZervantSettings()
  const { customerForm } = useCustomerForm()
  const { getDefaultSettingsValue, isLoading: isLoadingZervantDocumentSettings } = useGetZervantDocumentSettings(
    InvoiceDocumentType.Invoice,
  )

  const { FormItem } = customerForm
  const isLoading = isLoadingSettings || isLoadingZervantDocumentSettings

  const paymentTermItems = useMemo(() => {
    const baseItems = data?.managedFields?.PAYMENT_TERMS ?? []
    return baseItems.map((paymentTerm) => ({
      id: String(paymentTerm),
      children: t('days_count', { count: paymentTerm }),
      value: paymentTerm,
    }))
  }, [data?.managedFields?.PAYMENT_TERMS, t])

  const defaultPaymentTerm = useMemo(() => {
    return getDefaultSettingsValue('paymentTime')
  }, [getDefaultSettingsValue])

  return (
    <FormItem
      itemColumnEnd={11}
      itemColumnStart={1}
      name="paymentTerm"
      label={t('customer_modal.form.payment_term.label')}
      render={({ field: { onChange, value: formValue, ...rest } }) => (
        <Select
          {...rest}
          autoFocus
          dropdownFetching={isLoading}
          dropdownSize="fitTrigger"
          items={paymentTermItems}
          onSelect={(_, value) => onChange(value)}
          selectedId={String(formValue ?? defaultPaymentTerm)}
          selectLook={false}
          size="sm"
          withSearch={false}
        />
      )}
    />
  )
}
